import { useState, useEffect } from "react";
import { Link } from "wouter";
import { ArrowRight, Phone } from "lucide-react";

/**
 * MobileCTA — Sticky bottom bar on mobile with "Begär offert" and phone CTA.
 * Only visible on screens < 768px (md breakpoint).
 * Hides when user is near the top of the page (hero visible) or at the footer.
 * Slides in/out smoothly.
 */
export default function MobileCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    function handleScroll() {
      const scrollY = window.scrollY;
      const docHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;

      // Show after scrolling past 400px (past hero)
      // Hide when near the bottom (footer area, last 300px)
      const pastHero = scrollY > 400;
      const nearBottom = scrollY + windowHeight > docHeight - 300;

      setIsVisible(pastHero && !nearBottom);
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Check initial state
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 md:hidden transition-transform duration-300 ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="bg-white border-t border-gray-200 shadow-[0_-4px_12px_rgba(0,0,0,0.08)] px-4 py-3">
        <div className="flex items-center gap-3">
          <a
            href="tel:016132600"
            className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-lg shrink-0 hover:bg-gray-200 transition-colors"
            aria-label="Ring ASPAB"
            onClick={() => {
              if ((window as any).dataLayer) {
                (window as any).dataLayer.push({
                  event: "phone_click",
                  phone_number: "016132600",
                  click_location: "mobile_cta",
                });
              }
            }}
          >
            <Phone className="w-5 h-5 text-gray-700" />
          </a>
          <Link
            href="/kontakt"
            className="flex-1 inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#2563EB] text-white font-semibold rounded-lg hover:bg-[#1D4ED8] transition-colors text-sm"
          >
            Begär offert
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
